<template>
	<Alert v-if="expired" :color="Color.Red">{{ trans('account.certificates.academic.expired') }}</Alert>
	<Alert v-else-if="expiring" :color="Color.Yellow">{{ trans('account.certificates.academic.expiring', {date: dayjs(certificate.expires_at).format(trans('general.dayjs.date'))}) }}</Alert>
	<Alert v-else-if="isValid" :color="Color.Green">{{ trans('account.certificates.academic.valid') }}</Alert>
	<Alert v-else-if="certificate" :color="Color.Red">{{ trans('account.certificates.academic.invalid') }}</Alert>
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import timezone from 'dayjs/plugin/timezone'
import Alert from '@/Components/Alerts/Alert.vue'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import {computed, type ComputedRef, defineProps, type Ref, ref} from 'vue'
import {type AcademicCertificate} from '@/Types/Tools/AcademicCertificate'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.tz.setDefault('America/Argentina/Buenos_Aires')

const props = defineProps<{
	certificate:AcademicCertificate,
}>()

const certificate:Ref<AcademicCertificate> = ref(props.certificate)

const expirationSet:ComputedRef<boolean> = computed(() => {
	return certificate.value !== null && certificate.value.expires_at !== null
})
const isValid:ComputedRef<boolean> = computed(() => {
	return certificate.value !== null && certificate.value.valid
})
const expired:ComputedRef<boolean> = computed(() => {
	return expirationSet.value && dayjs(certificate.value.expires_at).isSameOrBefore(dayjs(), 'day')
})
const expiring:ComputedRef<boolean> = computed(() => {
	return expirationSet.value && dayjs().isSameOrAfter(dayjs(certificate.value.expires_at).subtract(30, 'days'), 'day')
})
</script>